// Program poin (Figma Poin/Access). Belum ada endpoint poin di member-api: semua nilai 0 / kosong sampai
// backend tersedia (sebelumnya angka contoh Figma, yang tampak seperti data asli member).
export const POINTS_TOTAL = '0';
export const POINTS_THIS_MONTH = '+0';

/** Level member (kartu "Level Kamu" di Access): poin terkumpul dan target level berikutnya. */
export const LEVEL_POINTS = 0;
export const LEVEL_TARGET = 1000;

export type PointActivityType = 'ad' | 'gamification' | 'referral';

export const POINT_ACTIVITY_LABEL: Record<PointActivityType, string> = {
  ad: 'Menonton Iklan',
  gamification: 'Gamification',
  referral: 'Referal',
};

export interface PointActivity {
  id: string;
  title: string;
  user: string;
  /** Tanggal kalender WIB (YYYY-MM-DD) dan jam tampilan. */
  date: string;
  time: string;
  points: number;
  type: PointActivityType;
}

export const POINT_ACTIVITIES: PointActivity[] = [];
